/*
  CB 14/10/2026 - Cuore Wishlist (Vitals) nelle card prodotto, sotto il "+".
  Il cuore di Vitals resta dov'e' (nascosto, assets/overrides.css) e nel gruppo
  pulsanti della card viene aggiunto UNA SOLA VOLTA un pulsante cuore del tema
  (.cb-wl-btn), identico a lente e "+". Al clic il pulsante preme il cuore di
  Vitals della stessa card: salvataggio, avvisi e lista restano gestiti da Vitals.
  Lo stato (vuoto/pieno) viene copiato dal cuore di Vitals (aria-label "Aggiunto").
  Stile in assets/cb-fixes-1410.css (blocco 5).

  CB 15/10/2026: icona con lo stesso markup delle icone del tema (viewBox 64).

  CB 15/10/2026 (terzo giro): prima lo script partiva solo su home e collezioni.
  Nelle altre pagine (scheda prodotto: "Potrebbe piacerti", "Altro da...",
  "Visualizzati di recente"; ricerca; carrello...) il cuore di Vitals era nascosto
  ma il nostro non veniva creato: nessun cuore. Ora vale su tutte le pagine, per
  ogni card che ha il cuore di Vitals (anche quelle caricate dopo, es. i consigliati).
  Escluse solo le miniature prodotto dentro il menu dell'header.
*/
(function () {
  var ADDED_LABEL = 'Aggiunto'
  var ICON =
    '<element-icon><svg class="element-icon element-icon--line cb-wl-icon" viewBox="0 0 64 64" fill="none" aria-hidden="true" focusable="false" role="presentation">' +
    '<path d="M32 52S10 39 10 24c0-7.5 5.5-13 12.5-13 4.5 0 8 2.5 9.5 6.5 1.5-4 5-6.5 9.5-6.5C48.5 11 54 16.5 54 24c0 15-22 28-22 28z"/>' +
    '</svg></element-icon>'
  var timer = null

  function vitalsButton(card) {
    return card.querySelector('.Vtl-WishlistIcon__Wrapper .Vtl-WishlistButton__WishlistIconButton')
  }

  function inHeader(el) {
    return !!el.closest('.site-header, .header-section, .megamenu, .site-nav__dropdown, .slide-nav__wrapper')
  }

  function addButtons() {
    var groups = document.querySelectorAll('.grid-product .grid-product__actions')
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i]
      if (g.querySelector(':scope > .cb-wl-btn')) continue
      if (inHeader(g)) continue
      var b = document.createElement('button')
      b.type = 'button'
      b.className = 'text-link quick-add-btn cb-wl-btn'
      b.setAttribute('aria-pressed', 'false')
      b.setAttribute('aria-label', 'Aggiungi alla lista dei desideri')
      b.title = 'Lista dei desideri'
      b.innerHTML = '<span class="btn btn--circle btn--icon">' + ICON + '</span>'
      g.appendChild(b)
    }
  }

  function sync() {
    var btns = document.querySelectorAll('.cb-wl-btn')
    for (var i = 0; i < btns.length; i++) {
      var card = btns[i].closest('.grid-product')
      var v = card && vitalsButton(card)
      var on = !!(v && v.getAttribute('aria-label') === ADDED_LABEL)
      if (btns[i].classList.contains('is-added') !== on) {
        btns[i].classList.toggle('is-added', on)
        btns[i].setAttribute('aria-pressed', on ? 'true' : 'false')
        btns[i].setAttribute('aria-label', on ? 'Rimuovi dalla lista dei desideri' : 'Aggiungi alla lista dei desideri')
      }
    }
  }

  function schedule() {
    if (timer) return
    timer = setTimeout(function () {
      timer = null
      addButtons()
      sync()
    }, 60)
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.cb-wl-btn') : null
    if (!b) return
    e.preventDefault()
    e.stopPropagation()
    var card = b.closest('.grid-product')
    if (!card) return
    var tries = 0
    ;(function press() {
      var v = vitalsButton(card)
      if (v) {
        // v.click() non basta: Vitals ignora il clic senza "view"
        v.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
        setTimeout(sync, 400)
        setTimeout(sync, 1200)
      } else if (tries++ < 20) {
        // card appena caricata (es. consigliati): Vitals mette il suo cuore poco dopo
        setTimeout(press, 100)
      }
    })()
  }, true)

  function start() {
    addButtons()
    sync()
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label']
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }
})()